import { useState, useEffect, useRef } from 'react';
import { PinPhase } from 'shared/types/pin';

export interface IUsePinPhaseReturn {
  phase: PinPhase;
  showSimplePins: boolean;
  showPromoPinsContent: boolean;
  isSimpleExiting: boolean;
  isPromoExiting: boolean;
}

export const usePinPhase = (showPromoPins: boolean): IUsePinPhaseReturn => {
  const [phase, setPhase] = useState<PinPhase>(showPromoPins ? 'promo' : 'simple');
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearTimeoutRef = (): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const scheduleTransition = (delayMs: number, nextPhase: PinPhase): void => {
    timeoutRef.current = setTimeout(() => {
      setPhase(nextPhase);
      timeoutRef.current = null;
    }, delayMs);
  };

  useEffect(() => {
    if (showPromoPins) {
      if (phase === 'simple') {
        setPhase('exiting');
        scheduleTransition(601, 'promo');
      }

      return;
    }

    if (phase === 'promo') {
      setPhase('exitingPromo');
      scheduleTransition(601, 'simple');

      return;
    }

    if (phase !== 'exitingPromo') {
      clearTimeoutRef();
      setPhase('simple');
    }
  }, [showPromoPins, phase]);

  useEffect(() => clearTimeoutRef, []);

  return {
    phase,
    showSimplePins: phase === 'simple' || phase === 'exiting',
    showPromoPinsContent: phase === 'promo' || phase === 'exitingPromo',
    isSimpleExiting: phase === 'exiting',
    isPromoExiting: phase === 'exitingPromo',
  };
};
